@use "../../styles/breakpoint" as *;

.wrapper {
    background-image: url("../../../static/img/hardcoded/ceo-message-background.png");
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    padding: 3rem 0 1.5rem;
    overflow: hidden;
    text-align: center;
}

.title {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.96px;
    font-weight: 200;
    margin-bottom: 1.4rem;

    @media ($below-mobile) {
        letter-spacing: 0;
    }

    @media ($below-tiny) {
        max-width: 300px;
        margin: 0 auto 1rem;
    }
}

.copy {
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    max-width: 1070px;
    margin: 0 auto 2rem;

    @media ($below-tablet) {
        max-width: 639px;
    }

    @media ($below-mobile) {
        max-width: 555px;
    }

    @media ($below-tiny) {
        margin-bottom: 1.25rem;
        max-width: 300px;
    }
}

.signature {
    display: inline-block;
    height: 100px;
    padding-right: 5.25rem;
    text-align: center;
}

.name {
    font-weight: 200;
    transform: translateY(-2rem);
}
